import { useMemo } from 'react';
import { ApolloError } from '@apollo/client';
import { FormRenderProps } from 'react-final-form';
import { useNavigate } from 'react-router-dom';

import {
  Button,
  Container,
  PageHeader,
  useAppLayoutContextConsumer,
} from '@occc-app/design-system';
import { FormContent } from '@occc-app/routes/Campaign/components/FormContent';
import { UpdateCampaignForm } from '@occc-app/routes/Campaign/CampaignUpdatePage/UpdateCampaignForm';
import { getCampaignUpdatePageHeaderLinks } from '@occc-app/routes/Campaign/utils';

type UpdateCampaignFormRenderComponentProps = Pick<FormRenderProps, 'handleSubmit'> & {
  disabled: boolean;
  loading: boolean;
  loaded: boolean;
  name: string;
  campaignId: string;
  error?: ApolloError;
};

export const UpdateCampaignFormRenderComponent = ({
  handleSubmit,
  name,
  disabled,
  loading,
  loaded,
  error,
}: UpdateCampaignFormRenderComponentProps) => {
  const navigate = useNavigate();

  const links = useMemo(() => getCampaignUpdatePageHeaderLinks(name), [name]);

  useAppLayoutContextConsumer(links);

  // TODO: move Container and PageHeader to level up and replace it along with Helmet by Page component
  return (
    <Container variant='md' includesPageHeader>
      <PageHeader title='Campaign Update'>
        <Button
          variant='contained'
          data-testid='campaign-cancel-button'
          role='button'
          color='secondary'
          onClick={() => navigate(-1)}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          color='secondary'
          onClick={handleSubmit}
          disabled={disabled}
          data-testid='campaign-update-button'
        >
          Save
        </Button>
      </PageHeader>
      <UpdateCampaignForm
        loading={loading}
        loaded={loaded}
        error={error}
        handleSubmit={handleSubmit}
      >
        <FormContent />
      </UpdateCampaignForm>
    </Container>
  );
};
